/**
 * @typedef {import('./Props').default} Props
 */
import { translate } from '../../App/Internationalization';
import BaseButton from '../../shared/BaseButton/BaseButton';
import React from 'react';

/** @extends {React.Component<Props>} */
export class ImportLocation extends React.Component {
	/** @returns {JSX.Element} */
	render() {
		return (
			<BaseButton onClick={this.props.onToggle}>
				{translate('global.import.start_import')}
			</BaseButton>
		);
	}
}

export default ImportLocation;
